
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/ai-agents-in-action",
      function () {
        return require("private-next-pages/books/ai-agents-in-action.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/ai-agents-in-action"])
      });
    }
  